var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTable',{ref:"table",attrs:{"headers":_vm.headers,"items":_vm.tableData,"sort-by":"name"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h2',{staticClass:"ml-4"},[_vm._v("Schlösser")])]},proxy:true},{key:"item.available_keys",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.amount_free_keys)+" / "+_vm._s(item.amount_keys)+" ")]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":("/lock/" + (item.id))}},[_vm._v(_vm._s(item.name))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }